import axios from "axios";
import { Result } from "@/models/Result";
import { requestConfig } from "./ApiService";
import ConfigService from "../ConfigService";

export default {
	getTikTokConnectData(clientId?: number, checklistClientId?: number, message?: string): Promise<Result> {
		return new Promise((resolve, reject) => {
			const url = new URL(ConfigService.tiktokConnectDataUrl);
			const config = {
				...requestConfig,
				params: {
					checklistClientId,
					clientId,
					message,
				}
			};
			axios
				.post(url.toString(), null, config)
				.then((response) => {
					const result: Result = response.data;
					resolve(result);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	loginCustomer(clientId: number): Promise<Result> {
		return new Promise((resolve, reject) => {
			const url = new URL(ConfigService.tiktokLoginCustomerUrl);

			var w = 850;
			var h = 800;
			var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
			var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
			var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
			var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
			var systemZoom = width / window.screen.availWidth;
			var left = (width - w) / 2 / systemZoom + dualScreenLeft
			var top = (height - h) / 2 / systemZoom + dualScreenTop

			const win = window.open(url + "?clientID=" + clientId, "windowname1", "width=" + w / systemZoom + ", height=" + h / systemZoom + ", top=" + top + ", left=" + left);
			let checkWinClosed = setInterval(function () {
				if (win && win.closed) {
					clearInterval(checkWinClosed);
					const result: Result = {
						Message: "",
						Success: true,
					};
					resolve(result);
				}
			}, 200);
		});
	},

	sendConnectMessage(email: string, clientName: string, msg: string): Promise<Result> {
		return new Promise((resolve, reject) => {
			const url = new URL(ConfigService.tiktokSendConnectMessageUrl);
			const config = {
				...requestConfig,
				params: {
					clientName,
					email,
					msg,
				}
			};
			axios
				.post(url.toString(), null, config)
				.then((response) => {
					resolve({
						Message: response.data.message,
						Success: response.data.success,
					});
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
